// ***********************************
// Batch.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>
      <br/>
      <b-form @submit="deleteBatch" @reset="onReset">
      <b-card header="Delete Batch">
        <b-list-group>
          <b-list-group-item>
            <div>
              <div id="demo">
                
                <br/>
                Databases in this Batch Definition:
               <b-table
                  :per-page="perPage"
                  :current-page="currentInputPage"
                  striped
                  hover
                  responsive
                  bordered
                  :items="batchItems"
                  :fields="inputFields"
                  :sort-by.sync="inputSortBy"
                  class="table table-sm"
                >

                  <template #cell(database)="row">
                    <a v-b-tooltip.hover :title="`${row.item.description}`" :href="`/metrics/${row.item.collectionID}/ora_v1`" target="_blank">{{ row.item.database }}</a>
                  </template>
                  <!--<template #cell(collectionID)="data">-->
                  <!--  <a :href="`/metrics/${data.value}/ora_v1`" target="_blank">{{ data.value }}</a>-->
                  <!--</template>-->
                </b-table>
                <b-pagination
                  :total-rows="batchItems.length"
                  :per-page="perPage"
                  v-model="currentInputPage"
                  size="sm"
                  align="center"
                />
 
                <br/><br/><br/>
              </div>

              <div>
                <b-form-group label="Delete databases from DBCSI too?" label-cols="3" label-size="sm">
                  <b-form-select v-model="delete_databases" size="sm" >
                    <option value="yes">Yes- delete the batch definition AND all of the databases from DBCSI</option>
                    <option value="no">No- delete the batch definition BUT leave the databases in DBCSI</option>
                  </b-form-select>
                </b-form-group>

                <b-button
                  type="button"
                  block
                  variant="outline-primary"
                  v-b-modal.modal-1
                >Delete this Batch Definition</b-button>
                <b-modal id="modal-1" title="Confirm Delete" okVariant="danger" @ok="deleteBatch">
                  <p class="my-4" v-if="delete_databases=='no'">Are you sure you want to delete this batch?</p>
                  <p class="my-4" v-if="delete_databases=='yes'">Are you sure you want to delete this batch AND its databases?</p>
                  <b-alert :show="showAlertdelete" :variant="alertStyledelete">{{alertTextdelete}}
                    <div v-show="showAlertdelete && alertStyledelete=='success'">
                      <router-link :to="{ name: 'BatchHome' }">Click here to continue</router-link>
                    </div>
                  </b-alert>
                </b-modal>

                <br>
              </div>
              

              
              
            </div>
          </b-list-group-item>

        </b-list-group>
      </b-card>


      </b-form>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import axios from "axios";
import flatten from "flat";

export default {
  name: "app",
  components: {
  },
  async created() {    
    var tries = 2;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/batch/${this.batch_id}`
      )
        .then(response => {
					// console.log("get batch success "+response.success);
					if (response.success) {
          this.batchItems = response.data;
          
          //are any of these batchItems non X86?
          for (var i of this.batchItems) {
            if (i.PLATFORM_NAME!="Linux_x86_64-bit") {
              this.showAlertNonX86 = true;
              this.alertTextNonX86 = "Warning: Your batch contains non-Linux platforms.  Please enter a CPU thread mapping ratio value.";
              this.NonX86Platform = i.PLATFORM_NAME;
              break;
            }
          }  
					tries = 0;
					// console.log("get batch set batchItems:"+this.batchItems.length);
					}
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Batch-batchItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
      tries -= 1;
		}


    // console.log("I am here4");
  },
  props: ["batch_id", "user"],
  data() {
    return {
      delete_databases: "no",
      showAlert: false,
      showAlertNonX86: false,
      showAlertdelete: false,
      showTableEdit: false,
      NonX86Platform: "",
      alertText: "",
      alertTextNonX86: "",
      alertTextdelete: "",
      alertStyle: "default",
      alertStyledelete: "default",
      
      comments: {
        General: "",
        DiskSpace: "",
        CPU: "",
        Memory: "",
        IO: "",
        Backup: "",
        EC2: "",
        RDS: "",
        Waits: "",
        Exadata: "",
        Aurora: ""
			},		
      batchItems: [{ database: "Retrieving Data..." }],
      flatItems: [{ database: "to be computed..." }],
      inputSortBy: "row",
      outputSortBy: "row",
      ec2: {
        VCPU: "",
        Memory: "",
        Throughput: ""
      },
      ec2extras: {
        CPU_src: "",
        CPU_src_specint: "",
        VCPU_adj_other: "",
        ec2_shape: "",
        rds_shape: "",
        aurora_shape: "",
        aurora_flavor: ""
      },
      ebs: {
        DiskSpace: "",
        DiskSpace_src: "",
        DiskSpace_adj_other: "",
        IOPS: "",
        Backup: "",
        VolumeType: "gp2",
        SnapshotDays: "",
        BackupType: "none",
        aurora_IOPS_adj: ""
      },
      selected: [],
      rdsSelected: [],
      auroraSelected: [],
      currentInputPage: 1,
      perPage: 10,
      currentOutputPage: 1,
     inputFields: [
        {row: {
          label: "row",
          sortable: true
        }},
        // {collectionID: {
        //   label: "Collection",
        //   sortable: true
        // }},
        {database: {
          label: "Database",
          sortable: true
        }},
        {description: {
          label: "Description",
          sortable: true
        }},
        {hostname: {
          label: "Host",
          sortable: true
        }},
        {CONSOLIDATED_DATABASES: {
          label: "Consolidated?",
          sortable: true
        }},
        {collectionID: {
          label: "CollectionID",
          sortable: true
        }}
      ]


    };
  },
  methods: {

    
    async deleteBatch(evt) {
      evt.preventDefault();
      this.alertStyledelete="primary";
      this.alertTextdelete = "Deleting Batch... Please wait...";
      this.showAlertdelete = true;

     //delete_databases yes or no
      //console.log("deleteTargets: I am here1");
      var tries = 2;
      var success = true;
      
      if (this.delete_databases=='yes') {
        console.log("Delete databases=yes");
      
// if delete_databases is yes
// loop
        for (var i of this.batchItems) {
          // set alertTextdelete to Do Not Leave this page.  Deleting i of length
          // delete database.
          // set database name to "Deleted" or remove row from array
          this.alertTextdelete = "Do not leave page yet.  Deleting "+i.row+" of "+ this.batchItems.length;
          console.log("Deleting database",i.collectionID, i.row);

          
          //
          await API.del(
            "dbcsiAPI",
            `/dbcsi/${i.collectionID}`
          )
            .then(response => {
              success = response.success;
              if (success) {
                i.description="DELETED";
              } else {
                console.log("BatchDelete- deleteCollection.delete Error:", response.data.reason);
                this.alertTextdelete = "ERROR: " + response.data.reason;
              }
            })
            .catch(error => {
              console.log("BatchDelete- deleteCollection.delete Error:", error);
                // this.alertText = "Error while deleting: "+error;
                // this.alertStyle="danger"
              this.alertTextdelete = "Database unable to be deleted.";   
                success=false;
            });
            
           
          
          
          //
        }
        
      }
      
      success=true; //try to delete the batch even if you can't delete the individual databases
      this.alertTextdelete = "Deleting batch definition";

      if (success) {
      
        // is this CONSOLIDATED_DATABASES
        if (this.batchItems.length > 0 && this.batchItems[0].CONSOLIDATED_DATABASES*1>0) {
          var i=0;
          console.log("deleting consolidated database ", this.batchItems[i].collectionID, this.batchItems[i].database);
          await API.del(
            "dbcsiAPI",
            `/dbcsi/${this.batchItems[i].collectionID}`
          );

        }
        

        await API.del(
          "dbcsiAPI",
          `/dbcsi/batch/${this.batch_id}`
        )
          .then(response => {
            success = response.success;
            if (success) {
              this.alertTextdelete = "Batch deleted.";
              console.log("Batch- batch delete success");
            } else {
            console.log("Batch- batch delete Error:", response.data.reason);
              this.alertTextdelete = "ERROR: " + response.data.reason;
            }
          })
          .catch(error => {
            console.log("Batch- delete batch Error:", error);
              // this.alertText = "Error while deleting: "+error;
              // this.alertStyle="danger"
            this.alertTextdelete = "Batch unable to be deleted.  Please try again.";   
              success=false;
          });
        
        

        
        if (success) {
        this.alertTextdelete = "Deleting Batch Finished.";
        this.alertStyledelete="success";
        this.$router.push('/batchhome') ;
        }
        console.log("Batch- delete: done");
      }
      
     
      // console.log("Metrics- deleteCollection: done");

      // this.$router.push('/') ;
      // console.log("Metrics- deleteCollection: done2");

    },
    


    onReset(evt) {
      evt.preventDefault();
    }
  },
  computed: {

  }
};
</script>

<style>
</style>
